import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapMutations } from 'vuex';
import EditResource from './edit-resource.vue';
import { fmtSize } from '@/filters/index.js';
import categoryMixins from '@/views/creative/mixin/category';
import isMaterialWarehouse from '@/common/is-warehouse.js';
import { getFileExtension } from '@com/utils/file';
import _ from 'lodash';

export default {
  mixins: [categoryMixins],
  data: function data() {
    return {
      currentPopupTop: 0
    };
  },
  components: {
    EditResource: EditResource
  },
  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentCategory: function currentCategory(state) {
      return state.creative.template.currentCategory;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    templateId: function templateId(state) {
      return state.creative.template.id;
    },
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    },
    currentResourceGroupTop: function currentResourceGroupTop(state) {
      return state.creative.template.currentResourceGroupTop;
    }
  }), {
    category: function category() {
      return this.currentCategory;
    },
    title: function title() {
      if (this.isAudio) {
        return this.$t('playTurbo.custom.editResourceDialog.title.audio');
      } else if (this.isImage) {
        return this.$t('playTurbo.custom.editResourceDialog.title.image');
      } else if (this.isFrameSequence) {
        return this.$t('playTurbo.custom.editResourceDialog.title.movieClip');
      } else if (this.isDragonBones) {
        return this.$t('playTurbo.custom.editResourceDialog.title.dragonBones');
      } else if (this.isModel) {
        return this.$t('playTurbo.custom.editResourceDialog.title.model');
      }
      return '';
    },
    extra: function extra() {
      return this.currentResource.extra || {};
    },
    fileExt: function fileExt() {
      var baseResourcePreviewUrls = this.currentResource.preview_urls;
      if (this.isModel) {
        // laya 模型包含lm文件判断含有fbx
        // cocos模型包含json、.bin文件判断含有fbx
        var hasFbx = function hasFbx(ext) {
          return ext === 'lm' || ext === 'json' || ext === 'bin';
        };
        return 'Zip (' + _.uniq(baseResourcePreviewUrls.map(function (a) {
          var ext = String(getFileExtension(a)).toLowerCase();
          return hasFbx(ext) ? 'fbx' : ext;
        })).join(' + ') + ')';
      }
      return getFileExtension(this.currentResource.file_name);
    },
    fileMetaData: function fileMetaData() {
      var data = [{
        label: this.$t('playTurbo.custom.resourceDialog.fileMetaData.name'),
        value: this.currentResource.file_name
      }, {
        label: this.$t('playTurbo.custom.resourceDialog.fileMetaData.format'),
        value: this.fileExt.toUpperCase()
        // value: this.currentResource.file_name.split('.')[1]
      }];
      if (this.extra.file_size) {
        data.push({
          label: this.$t('playTurbo.custom.resourceDialog.fileMetaData.fileSize'),
          value: fmtSize(this.extra.file_size)
        });
      }
      if (this.extra.width && this.extra.height) {
        var label = this.$t('playTurbo.custom.resourceDialog.fileMetaData.size');
        if (this.isImage) {
          label = this.$t('playTurbo.custom.resourceDialog.fileMetaData.imageSize');
        } else if (this.isVideo) {
          label = this.$t('playTurbo.custom.resourceDialog.fileMetaData.videoSize');
        }
        data.push({
          label: label,
          value: this.extra.width + '*' + this.extra.height
        });
      }
      return data;
    }
  }),
  mounted: function mounted() {
    console.log('MOUNTED:', this.$el.offsetHeight);
  },


  watch: {
    'editResourceDialog.visible': function editResourceDialogVisible(val) {
      // 资源弹窗隐藏时不清空当前资源与分类
      if (val === false) {
        this.updateCurrentResource(null);
        this.closeEditResourceDialog();
      }
    },
    currentResourceGroupTop: function currentResourceGroupTop(crgTop) {
      var _this = this;

      setTimeout(function () {
        _this.setCurrentPopupTop(crgTop);
      }, 0);
    }
  },

  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog'
  }), {
    // 轮询nextTick直至元素有高度
    getElHeight: function getElHeight() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var getHeight, height;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getHeight = function getHeight() {
                  return new _Promise(function (res, rej) {
                    setTimeout(function () {
                      if (_this2.$refs.popup) {
                        res(_this2.$refs.popup.offsetHeight);
                      } else {
                        res(0);
                      }
                    }, 0);
                  });
                };

                _context.next = 3;
                return getHeight();

              case 3:
                height = _context.sent;

                if (height) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return _this2.getElHeight();

              case 7:
                height = _context.sent;

              case 8:
                return _context.abrupt('return', height);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setCurrentPopupTop: function setCurrentPopupTop(crgTop) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var popupHeight, navHeight, maxTop, miniTop, computedTop;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getElHeight();

              case 2:
                popupHeight = _context2.sent;

                console.log(popupHeight);
                navHeight = isMaterialWarehouse() ? 60 : 64;
                maxTop = window.innerHeight - popupHeight - navHeight;
                miniTop = 0;
                computedTop = crgTop - navHeight;

                if (computedTop < miniTop) {
                  _this3.currentPopupTop = 0;
                } else if (computedTop > maxTop) {
                  _this3.currentPopupTop = maxTop + 'px';
                } else _this3.currentPopupTop = computedTop + 'px';

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  })
};